import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { whatsappLink } from "@/lib/clinic";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Founder", href: "#founder" },
  { label: "Stories", href: "#testimonials" },
  { label: "Visit", href: "#contact" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.jpg"
            alt="Revive Ripple"
            className="w-12 h-12 rounded-full object-cover ring-1 ring-forest-900/10"
          />
          <span className="font-serif text-2xl tracking-tight text-forest-900 hidden sm:inline">
            Revive <span className="italic text-terracotta-500">Ripple</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className="text-sm tracking-wide text-forest-900/75 hover:text-terracotta-500 transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-book-btn"
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-forest-800 hover:bg-forest-900 text-sand-50 px-6 py-3 text-sm tracking-wide transition-all hover:-translate-y-0.5"
        >
          Book a Session
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-forest-900/20 text-forest-900"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-sand-50/95 backdrop-blur-xl border-t border-forest-900/10"
        >
          <ul className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                  className="block text-lg font-serif text-forest-900"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-nav-book-btn"
                className="inline-flex items-center justify-center w-full rounded-full bg-terracotta-500 text-sand-50 px-6 py-3 mt-2"
              >
                Book on WhatsApp
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
